import React, { useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

export default function PublicEnquiry() {
  const [form, setForm] = useState({ customer_name: "", phone: "", email: "", product: "", details: "", deadline: "" });
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { ...form };
      if (!payload.deadline) delete payload.deadline;
      await api.post("/public/enquiries", payload);
      setDone(true);
    } catch { toast.error("Failed to submit"); }
    finally { setLoading(false); }
  };

  if (done) {
    return (
      <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center p-4">
        <Card className="max-w-md w-full p-8 text-center">
          <CheckCircle2 className="w-16 h-16 text-emerald-500 mx-auto mb-4" />
          <h2 className="text-2xl font-display font-bold mb-2">Thank you!</h2>
          <p className="text-muted-foreground">Your request has been sent. The Rozfa team will contact you shortly.</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 py-10 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-3 mb-3">
            <img src="/rozfa-logo.jpg" alt="Rozfa Print Ops" className="h-12 w-auto dark:hidden" />
            <img src="/rozfa-logo-white.png" alt="Rozfa Print Ops" className="h-12 w-auto hidden dark:block" />
            <div className="text-left">
              <div className="text-xs text-muted-foreground font-mono">Request a Quote</div>
            </div>
          </div>
          <h1 className="text-3xl font-display font-extrabold">Request a Quotation</h1>
          <p className="text-muted-foreground mt-1">Fill in the form below and our team will contact you</p>
        </div>

        <Card className="p-6">
          <form onSubmit={submit} className="space-y-4" data-testid="public-enquiry-form">
            <div className="grid md:grid-cols-2 gap-3">
              <div><Label>Full Name *</Label><Input required value={form.customer_name} onChange={e=>setForm({...form,customer_name:e.target.value})} data-testid="enq-name" /></div>
              <div><Label>Phone *</Label><Input required value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} data-testid="enq-phone" /></div>
            </div>
            <div><Label>Email</Label><Input type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} data-testid="enq-email" /></div>
            <div><Label>Product / Print Type *</Label><Input required placeholder="e.g. Business Card, Banner..." value={form.product} onChange={e=>setForm({...form,product:e.target.value})} data-testid="enq-product" /></div>
            <div><Label>Deadline (when do you need it?)</Label><Input type="date" value={form.deadline} onChange={e=>setForm({...form,deadline:e.target.value})} data-testid="enq-deadline" /></div>
            <div><Label>Additional Details</Label><Textarea rows={4} value={form.details} onChange={e=>setForm({...form,details:e.target.value})} placeholder="Size, quantity, material, etc." data-testid="enq-details" /></div>
            <Button type="submit" disabled={loading} className="w-full bg-cyan-600 hover:bg-cyan-700 text-white" data-testid="enq-submit">
              {loading ? "Sending..." : "Send Request"}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
